import {useState} from 'react';
import {StorageObject} from '../models/StorageObject';
import {useMutation, useQueryClient} from 'react-query';
import {STORAGE_OBJECTS_QUERY_KEY} from '../init/constants';
import {APIClient} from '../backend/ApiClient';
import {EditFileDTO} from '../models/dto/EditFileDTO';

export const useEditFile = () => {
    const queryClient = useQueryClient();
    const apiClient = APIClient();

    const [fileToEdit, setFileToEdit] = useState<StorageObject | null>(null);

    const editFileApiCall = (editFileDTO: EditFileDTO) => {
        return apiClient.updateFile(editFileDTO.thumbnail, editFileDTO.item);
    };

    const {mutateAsync: editFileMutation, isLoading} = useMutation(editFileApiCall, {
        onSuccess: () => {
            queryClient.invalidateQueries(STORAGE_OBJECTS_QUERY_KEY);
            setFileToEdit(null);
        }
    });

    const editFile = (editFileDTO: EditFileDTO) => {
        return editFileMutation(editFileDTO);
    };

    return {fileToEdit, setFileToEdit, editFile, isLoading};
};
